// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xDzm","top":"styles_top__3K4hy"};